module.exports = __webpack_public_path__ + "img/ajuda-pedale.b9c04c45.jpg";